export default __webpack_public_path__ + "static/media/9.db4111c1.jpg";